import React from "react";

const SpinnerLoader = () => {
	return (
		<div
			className="lds-spinner inline-block relative w-[80px] h-[80px]"
			data-testid="spinner-loader"
		>
			{Array.from({ length: 12 }).map((_, index) => (
				<div
					key={index}
					style={{
						transformOrigin: "40px 40px",
						transform: `rotate(${30 * index}deg)`,
						animation: "lds-spin 1.2s linear infinite",
						animationDelay: `${-1.1 + 0.1 * index}s`,
					}}
				/>
			))}
		</div>
	);
};

export default SpinnerLoader;
